import dayjs from "dayjs";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportMaquinasEquipUseCase } from "../../../presentation/useCases/read/get_report_maquinas_equip_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportMaquinasEquipUseCase
 */

export class GetReportMaquinasEquipUseCase implements IGetReportMaquinasEquipUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportMaquinasEquip(
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportMaquinasEquip(requiredMimeType);

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `maquinas_equip_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
